const toggleMobileNav = document.querySelector('.toggle-mobile-nav');

export default function mobileNav () {
    if (!toggleMobileNav) return;

    toggleMobileNav.addEventListener('click', function (evt) {
        document.body.classList.toggle('mobile-nav-open');
        evt.stopPropagation();
    });


    document.body.addEventListener('click', evt => {
        if (evt.target === document.body && document.body.classList.contains('mobile-nav-open')) {
            document.body.classList.remove('mobile-nav-open');
        }
    });
}
